import React, { Component } from 'react';
import { connect } from 'react-redux';
//import * as types from 'constants/actionTypes';
import { Button } from '@mui/material';

const styles = {
    uploadButton: {
        verticalAlign: 'middle'
    },
    uploadInput: {
        cursor: 'pointer',
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        width: '100%',
        opacity: 0
    }
};

class FileInput extends Component {
    constructor(props) {
        super(props);
        if (props.value) //if store has value relative to this component, initialize the state value
            this.state = { ...this.state, value: props.value, error: "" };
        else //in case the store does not have any value for this component, just clear it
            this.state = { ...this.state, value: "", error: "" };
    }

    componentWillReceiveProps(newProps) {
        if (newProps.value && newProps.value !== this.state.value)//if store's value relative to this component change, update the state value
            this.setState({ value: newProps.value });
        else if (!newProps.value)//in case the store does not have any value for this component, just clear it
            this.setState({ value: "" });

        if (newProps.error && newProps.error !== this.state.error)
            this.setState({ error: newProps.error });
    }

    onBlur = (event) => {
        this.updateStore(event.target.value);
    }

    render() {
        const p = this.props;
        //const s = this.state;

        return (
            <div className={p.className || "form-group"}>
                <Button
                    variant="contained"
                    component="label"
                    style={styles.uploadButton}
                >
                    {p.label}
                    <input
                        type="file"
                        name={p.name}
                        style={styles.uploadInput}
                        hidden
                        onChange={(e) => p.onChange(e)}
                    />
                </Button>
            </div>
        );
    }
}

const mapStateToProps = (state, props) => {
    return {
        value: state.form[props.name],
        error: state.form && state.form.error && state.form.error[props.name]
    };
};

export default connect(mapStateToProps)(FileInput);